<suggest-tag>
    <script>
        import debounce  from 'debounce-promise'
        import di from "dependeny-injection"

        export default {
            inverted: new Map(),
            list: [],
            kev: new KeyboardEvent('keydown', { keyCode: 33 }),
            choose:  new CustomEvent('choose', {cancelable: true}),
            onMounted(props, state) {
                this.root.onfocus = e => {
                    this.root.dispatchEvent(this.kev)
                }
                this.root.onkeyup =
                this.root.onpaste =
                this.root.onblur =
                this.root.onchange = debounce(e => {
                    if (0 === e.target.value.length) {
                        this.root.setAttribute('val', '')
                        this.root.dispatchEvent(this.choose)
                    }
                }, 100)
            },
            onBeforeUpdate(props, state) {
                this.inverted.clear()
                this.list = []
                for (let idx in props.data) {
                    this.inverted.set(props.data[idx], idx)
                    this.list.push(props.data[idx])
                }
                $(this.root).autocomplete({
                    source: this.list,
                    autoFocus: true,
                    delay: 300,
                    minLength: 0,
                    select: (e, ui)=>{
                        if (this.inverted.has(ui.item.value)) {
                            this.root.setAttribute('val', this.inverted.get(ui.item.value))
                            this.root.dispatchEvent(this.choose)
                        }
                    }
                })
            }
        } // export default
    </script>
</suggest-tag>
